"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupTraefik = void 0;

var TRAEFIK_MISSING_MIDDLEWARE_1 = require("./TRAEFIK_MISSING_MIDDLEWARE");

var TRAEFIK_MISSING_SERVICE_1 = require("./TRAEFIK_MISSING_SERVICE");

var TRAEFIK_MISSING_TLS_OPTIONS_1 = require("./TRAEFIK_MISSING_TLS_OPTIONS");

var TRAEFIK_UNUSED_MIDDLEWARE_1 = require("./TRAEFIK_UNUSED_MIDDLEWARE");

var TRAEFIK_UNUSED_SERVICE_1 = require("./TRAEFIK_UNUSED_SERVICE");

var TRAEFIK_UNUSED_TLS_OPTIONS_1 = require("./TRAEFIK_UNUSED_TLS_OPTIONS");

function setupTraefik(builder) {
  TRAEFIK_MISSING_MIDDLEWARE_1.setupTRAEFIK_MISSING_MIDDLEWARE(builder);
  TRAEFIK_MISSING_SERVICE_1.setupTRAEFIK_MISSING_SERVICE(builder);
  TRAEFIK_MISSING_TLS_OPTIONS_1.setupTRAEFIK_MISSING_TLS_OPTIONS(builder);
  TRAEFIK_UNUSED_MIDDLEWARE_1.setupTRAEFIK_UNUSED_MIDDLEWARE(builder);
  TRAEFIK_UNUSED_SERVICE_1.setupTRAEFIK_UNUSED_SERVICE(builder);
  TRAEFIK_UNUSED_TLS_OPTIONS_1.setupTRAEFIK_UNUSED_TLS_OPTIONS(builder);
}

exports.setupTraefik = setupTraefik;